import type { CheckoutReceipts } from '../types';
import {
  createCheckoutReceipts,
  createInstalmentReceipt,
} from './common';

export const ONE_INSTALMENT: CheckoutReceipts = createCheckoutReceipts({
  [1]: createInstalmentReceipt(1),
});

export const TWO_INSTALMENTS: CheckoutReceipts = createCheckoutReceipts({
  [1]: createInstalmentReceipt(1),
  [2]: createInstalmentReceipt(2, { partialAmount: '209.29' }),
});

export const TWO_INSTALMENTS_WITH_FEES: CheckoutReceipts = createCheckoutReceipts({
  [1]: createInstalmentReceipt(1),
  [2]: createInstalmentReceipt(2, {
    amountLocalTotal: '428.58',
    partialAmount: '214.29',
  }),
});
